import {
    MainSocket,
    WS_EVENT_UPDATE_ACTION,
    WS_EVENT_INPLAY_UPDATE_ACTION,
} from '../../shared/services/mainSocketClass';
import { IPW_WS_HANDLER_COMPONENT_NAME } from './components/constants';
import { getWsInterface } from '../../spa/Utils/Websockets';

export class InplaySocket extends MainSocket {
    constructor(wsInterface) {
        super(wsInterface);
        this.wsInterface = wsInterface;
        this.removeJsHandlerCallbacks = [];
    }

    removeWsEventHandlers() {
        this.removeJsHandlerCallbacks.forEach(cb => cb());
        this.wsEventUpdateListeners = new Set();
        this.isWsEventHandlersSet = false;
    }

    setWsEventHandlers() {
        this.removeJsHandlerCallbacks.push(this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_UPDATE_ACTION, this.wsEventUpdateHandler, IPW_WS_HANDLER_COMPONENT_NAME));
        this.removeJsHandlerCallbacks.push(this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_INPLAY_UPDATE_ACTION, this.wsEventUpdateHandler, IPW_WS_HANDLER_COMPONENT_NAME));
        this.isWsEventHandlersSet = true;
    }
}

const wsInterface = getWsInterface();
const inplaySocket = new InplaySocket(wsInterface);
export default inplaySocket;
